<div class="dialog-header">
    <div>
        <h6>Advanced Search</h6>
        <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
    </div>
</div>


<div *ngIf="showProgressBar" class="progress-bar-container">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div class="content-all">   
    <div class="content">
        <div class="adv-search-container" *ngIf="this.globalDataSharing._currentTab === 'ConflictCheck'">
            <div class="search-form" *ngFor="let field of searchFields; let i = index">

                <div class="search-input-container">
                    <mat-icon class="icon-search">search</mat-icon>
                    <input  #searchInput  class="input-search" type="text" [(ngModel)]="searchText[i]" (input)="onInputChange(i)" (keyup.enter)="search(this.globalDataSharing._currentTab)" placeholder="Search" [readonly]="false" >
                </div>

                <div>
                    <button *ngIf="i != (searchFields.length - 1)" mat-icon-button class="close" (click)="removeSearchField(i)">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="bottom-serach">
    <button mat-raised-button class="btn-search" [disabled]="!searchBtn"(click)="search(this.globalDataSharing._currentTab)">Search</button>
</div>
